@if (customer) {
  <hawk-record-navigation
    class="common_style app-page"
    [breadcrumbLinkList]="[
    { description: 'Kunden', link: '/a/kunde' },
    { description: customer.name, link: '/a/kunde/' + customer.id },
  ]"
    [root]="'customer'"
    [leafDescription]="'Filialen importieren'"
  >
    <div class="page-content page-frame overflow-y-auto">
      <div class="page-sheet min-w-xl mx-auto" style="width: fit-content;">
        <section class="bm-card max-w-xl">
          <div class="bm-card-body">
            <h2 class="bm-card-title flex flex-row justify-between">
              Format
              <button class="bm-btn bm-btn-sm bm-btn-circle" (click)="showFormatModal = true">
                <fa-icon [icon]="faInfoCircle" />
              </button>
            </h2>
            <fieldset class="bm-fieldset">
              <label class="bm-fieldset-label">Header-Zeile</label>
              <select class="bm-select w-full" [(ngModel)]="headerFormat" [disabled]="!!file">
                <option [value]="true">Vorhanden (Zeile 1 überspringen)</option>
                <option [value]="false">Nicht vorhanden</option>
              </select>

              <label class="bm-fieldset-label">Länder</label>
              <select class="bm-select w-full" [(ngModel)]="selectedCountryFormat" [disabled]="!!file">
                <option [value]="'full_name'">full-name</option>
                <option [value]="'3_letter'">3-letter</option>
              </select>

              <div class="input_row">
                <div class="input_label"></div>
                <div style="flex: 1" class="flex_col">
                  <div class="input_container">
                    @if (file) {
                      <div>
                        Auswahl: {{ file.name }}
                        <fa-icon style="cursor: pointer" [icon]="faTrash" (click)="resetFile()"></fa-icon>
                      </div>
                    } @else {
                      <label class="bm-fieldset-label">
                        Format: Excel
                      </label>
                    }
                    <input
                      #fileInput
                      type="file"
                      class="bm-file-input w-full"
                      (change)="incomingFile($event)"
                      [disabled]="!alreadyCreatedCustomerStores"
                      placeholder="Upload file"
                      accept="text/xlsx"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </section>

        @if (storeImportUnits?.length) {
          <div class="flex flex-row items-center justify-end py-2">
            <input
              type="text"
              class="bm-input"
              placeholder="Schnellfilter..."
              (input)="storeQuickSearchChanged($event)"
            />
          </div>
          <ag-grid-angular
            class="ag-theme-quartz"
            style="height: 480px; min-width: 90vw;"
            [rowData]="storeImportUnits"
            [theme]="hawkTheme"
            [defaultColDef]="defaultColDef"
            [columnDefs]="storeColDefs"
            [rowClassRules]="rowClassRules"
            [pagination]="true"
            [rowSelection]="rowSelection"
            [autoSizeStrategy]="autoSizeStrategy"
            [paginationPageSize]="16"
            [localeText]="locale"
            [sideBar]="sideBarOptions"
            [paginationPageSizeSelector]="[16, 32, 64, 128]"
            (gridReady)="onStoreGridReady($event)"
          />
        }
        @if (countryErrorForm) {
          <section [ngClass]="countryErrorForm.valid ? 'success' : 'error'">
            <h2>Formatierungsfehler</h2>
            <small class="text-muted">Bitte geben Sie die ISO3-Länder-Codes für folgende Länder an:</small>
            <form [formGroup]="countryErrorForm">
              @for (field of Object.keys(countryErrorForm.controls); track $index) {
                <label class="bm-fieldset-label">{{ field }}</label>
                <input class="bm-input" maxlength="3" style="text-transform: uppercase" [formControlName]="field" />
                <span class="text-error">Format: Genau 3 Buchstaben</span>
              }
            </form>
          </section>
        }
        <section class="bm-card">
          <div class="bm-card-body">
            <h2 class="bm-card-title flex flex-row justify-between">
              Verknüpfungen anlegen
              <button class="bm-btn bm-btn-sm bm-btn-circle" (click)="showFormatModal = true">
                <fa-icon [icon]="faInfoCircle" />
              </button>
            </h2>
            <fieldset class="bm-fieldset" style="max-width: 300px;">
              <mat-form-field appearance="outline" class="outline-small no-subscript">
                <mat-label>Projekte</mat-label>
                <mat-select [multiple]="true" [(ngModel)]="addProjectRelations">
                  @for (project of projects; track $index) {
                    <mat-option [value]="project.id">{{ project.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </fieldset>
          </div>
        </section>

        <div>
          @if (showSuccess) {
            <small class="text-success">{{ showSuccess }}</small>
          } @else if (showError) {
            <small class="text-error">Fehler beim Import: {{ showError }}</small>
          } @else {
            @if (storeImportUnits?.length && !importableUnits?.length) {
              <small> Hinweis: Alle Filialen wurden importiert! (Bestehende Filialen können geupdated werden) </small>
            }
            @if (importableUnits?.length) {
              <small>
                Hinweis: Noch {{ importableUnits?.length }}/{{ storeImportUnits?.length }} Filiale(n) zum importieren
              </small>
            }
          }
          @if (Number.isFinite(uploadProgress) && uploadProgress >= 0) {
            <hawk-progress-bar [progress]="uploadProgress"/>
            <div class="bm-label">Upload bei: {{Math.round(uploadProgress)}}%...</div>
          }
        </div>

        <div class="flex flex-row justify-end gap-2 mt-4">
          <a [routerLink]="'/kunde/' + customer.id" class="bm-btn"> Abbrechen </a>

          <button
            class="bm-btn bm-btn-primary"
            (click)="bulkImportStores()"
            [disabled]="(countryErrorForm && !countryErrorForm.valid) || Number.isFinite(uploadProgress) && uploadProgress >= 0"
          >
            Importieren
          </button>
        </div>
      </div>
    </div>
  </hawk-record-navigation>
}


@if (showFormatModal) {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <h3 class="text-lg font-bold">Beschreibung Excel Format</h3>
      <a
        class="bm-link bm-link-hover"
        download="FilialenImport.xlsx"
        href="assets/example-files/FilialenImport.xlsx"
      >
        Beispiel Excel runterladen
      </a>

      <table class="bm-table bm-table-xs bm-table-zebra text-nowrap w-full overflow-x-auto">
        <tr>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="'Eindeutige Bezeichnung (nr)'">
              Nr <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="'Firma (address_company)'">
              Firma <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="'Filialen-Name (name)'">
              Name <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="'Nachname-Adresse (address_lastname)'">
              Lastname <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>Straße</td>
          <td>HausNr</td>
          <td>PLZ</td>
          <td>Ort</td>
          <td>
            <span
              class="bm-tooltip"
              [attr.data-tip]="'3-Buchstabencode, Englischer/Deutscher Ländername oder leer für Deutschland'"
            >
              Land <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>Bundesland</td>
          <td>E-Mail</td>
          <td>Bemerkung</td>
          <td>Anzahl der Kassenplätze</td>
          <td>IP</td>
          <td>Telefon1</td>
          <td>Telefon2</td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="openingTooltip">
              Montag <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="openingTooltip">
              Dienstag <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="openingTooltip">
              Mittwoch <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="openingTooltip">
              Donnerstag <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="openingTooltip">
              Freitag <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="openingTooltip">
              Samstag <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
          <td>
            <span class="bm-tooltip" [attr.data-tip]="openingTooltip">
              Sonntag <fa-icon [icon]="faInfoCircle"></fa-icon>
            </span>
          </td>
        </tr>
        <tr>
          <td>C58_120356</td>
          <td>Lotterie Trapp B (2000066)</td>
          <td>Lotterie Trapp B</td>
          <td>SAP: XXXXXX</td>
          <td>Markt 12</td>
          <td>DE-25821</td>
          <td>Bredstedt</td>
          <td>Deutschland</td>
          <td>de-sh</td>
          <td>{{ "example@mail.de" }}</td>
          <td>Bemerkung 1</td>
          <td>3</td>
          <td></td>
          <td></td>
          <td>+49 1234 56789</td>
          <td>+49 1234 56790</td>
          <td>08:00-14:00#15:00-20:00</td>
          <td>08:00-20:00</td>
          <td>08:00-20:00</td>
          <td>08:00-20:00</td>
          <td>08:00-20:00</td>
          <td>08:00-20:00</td>
          <td></td>
        </tr>
        <tr>
          <td>...</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </table>

      <div class="bm-modal-action">
        <button class="bm-btn bm-btn-primary" (click)="showFormatModal = false">Schließen</button>
      </div>
    </div>
  </dialog>
}
